<template>
    <div class="page-table haberTanim mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.slider.guncelleme.pageBaslik")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="sliderForm" :rules="rulesSlider" ref="sliderForm" class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.slider.tanimlama.anaBaslik")'
                                                      prop="anaBaslik">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      v-model="sliderForm.anaBaslik"
                                                      :placeholder='$t("src.views.apps.slider.tanimlama.anaBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.slider.tanimlama.altBaslik")'
                                                      prop="altBaslik">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      v-model="sliderForm.altBaslik"
                                                      :placeholder='$t("src.views.apps.slider.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.slider.tanimlama.aciklama")'
                                                      prop="aciklama">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      type="textarea"
                                                      v-model="sliderForm.aciklama"
                                                      :placeholder='$t("src.views.apps.slider.tanimlama.aciklamaPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item>
                                            <el-checkbox v-model="checked">Slider'da Link Olsun Mu?</el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.slider.tanimlama.anaBaslikDil")'
                                                      prop="dil.en.anaBaslik">:
                                            <el-input
                                                    v-model="sliderForm.dil.en.anaBaslik"
                                                    v-on:change="$store.commit('changeTabsClose', false); sliderForm.dil.en.seoanaBaslik = sliderForm.dil.en.anaBaslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.slider.tanimlama.anaBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.slider.tanimlama.altBaslikDil")'
                                                      prop="dil.en.altBaslik">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      v-model="sliderForm.dil.en.altBaslik"
                                                      :placeholder='$t("src.views.apps.slider.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.slider.tanimlama.aciklamaDil")'
                                                      prop="dil.en.aciklama">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      type="textarea"
                                                      v-model="sliderForm.dil.en.aciklama"
                                                      :placeholder='$t("src.views.apps.slider.tanimlama.aciklamaPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                        <el-row v-if="checked" :gutter="10">
                            <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                <el-collapse-item :title='$t("src.views.apps.slider.tanimlama.link1Baslik")'
                                                  name="3">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.link")'
                                                          prop="link1">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                          v-model="sliderForm.link1"
                                                          :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.linkName")'
                                                          prop="link1">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                          v-model="sliderForm.linkButon1"
                                                          :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.slider.tanimlama.linkDilName")'
                                                    prop="linkButon1">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                          v-model="sliderForm.dil.en.linkButon1"
                                                          :placeholder='$t("src.views.apps.slider.tanimlama.linkNamePlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-col>
                            <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                <el-collapse-item :title='$t("src.views.apps.slider.tanimlama.link2Baslik")'
                                                  name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.link")'
                                                          prop="link2">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                          v-model="sliderForm.link2"
                                                          :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.linkName")'
                                                          prop="link1">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                          v-model="sliderForm.linkButon2"
                                                          :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.slider.tanimlama.linkDilName")'
                                                    prop="linkButon2">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                          v-model="sliderForm.dil.en.linkButon2"
                                                          :placeholder='$t("src.views.apps.slider.tanimlama.linkNamePlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-collapse-item class="margin-top-10 animated fadeInUp" title="Slider Tema Ayarları"
                                              name="7">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.slider.tanimlama.background")'
                                                      prop="background">:
                                            <el-carousel class="padding-top-10"
                                                         v-on:change="$store.commit('changeTabsClose', false); sliderChange"
                                                         :autoplay="false" id="sliderBack" type="card"
                                                         height="200px">
                                                <el-carousel-item>
                                                    <img style="width: 100%;height: 100%"
                                                         src="@/assets/images/slider/1.jpg">
                                                </el-carousel-item>
                                            </el-carousel>
                                        </el-form-item>
                                        <el-divider></el-divider>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.slider.tanimlama.resim")'
                                                      prop="resim">:
                                            <el-carousel class="padding-top-10"
                                                         v-on:change="$store.commit('changeTabsClose', false); resimChange"
                                                         :autoplay="false" type="card"
                                                         height="200px">
                                                <el-carousel-item>
                                                    <img style="float: right;width: 50%;height: 100%"
                                                         src="@/assets/images/sliderResim/1.png">
                                                </el-carousel-item>
                                                <el-carousel-item>
                                                    <img style="float: right;width: 50%;height: 100%"
                                                         src="@/assets/images/sliderResim/2.png">
                                                </el-carousel-item>
                                                <el-carousel-item>
                                                    <img style="float: right;width: 50%;height: 100%"
                                                         src="@/assets/images/sliderResim/3.png">
                                                </el-carousel-item>
                                                <el-carousel-item>
                                                    <img style="float: right;width: 50%;height: 100%"
                                                         src="@/assets/images/sliderResim/4.png">
                                                </el-carousel-item>
                                            </el-carousel>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </el-row>
                    </el-collapse>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.slider.tanimlama.durum")'>
                            <el-row>
                                <div>
                                    <el-button size="mini" class="onayBtn"
                                               v-on:click="sliderGuncelle('sliderForm')"
                                               type="primary">
                                        {{$t('src.views.apps.sayfa.guncelleme.sayfaguncelle')}}
                                    </el-button>
                                </div>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.slider.tanimlama.oncekiSlider")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="sliderTuru">
                                        <el-tree
                                                :data="sliderList"
                                                @node-click="handleNodeClick"
                                                node-key="sliderKodu"
                                                :props="defaultProps">
                                        </el-tree>
                                    </el-form-item>
                                    <div style="font-style: italic">* Eklenen Slider'ın hangi Slider'dan
                                        sonra gelmesini istersiniz?
                                    </div>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';

    let $ = JQuery;
    import draggable from 'vuedraggable'
    import sliderService from '../../../WSProvider/SliderService'
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataEstas = "";

    export default {
        name: "SliderDuzenle",
        components: {
            draggable
        },
        data() {
            return {
                sliderSrc: [
                    '@/assets/images/slider/1.jpg',
                    '@/assets/images/slider/2.jpg',
                    '@/assets/images/slider/3.jpg',
                    '@/assets/images/slider/4.jpg',
                    '@/assets/images/slider/5.jpg',
                ],
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                imageListServer: [],
                fileListServer: [],
                sliderDetayKlon: [],
                updateSliderKodu: '',
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                //Tree
                visibleUstSlider: false,
                treeList: [],
                defaultProps: {
                    label: 'anaBaslik'
                },
                // Form
                checked: false,
                visibleSil: false,
                imageListMain: [],
                fileListMain: [],
                sliderList: [],
                updateData: [],
                updateDataEN: [],
                defaultBackground: '',
                sliderForm: {
                    anaBaslik: "",
                    altBaslik: "",
                    aciklama: "",
                    resim: "",
                    background: "",
                    durum: "1",
                    link1: '',
                    linkButon1: '',
                    link2: '',
                    linkButon2: '',
                    // sliderTuru: '0',
                    oncekiSliderKodu: '',
                    dil: {
                        en: {
                            anaBaslik: '',
                            altBaslik: '',
                            aciklama: '',
                            linkButon1: '',
                            linkButon2: ''
                        }
                    }
                },
                rulesSlider: {
                    anaBaslik: [{
                        required: true,
                        message: "Lütfen AnaBaşlık Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        mounted() {
            this.updateSliderKodu = this.$store.state.updateKodu;
            this.getSliderDetay(this.updateSliderKodu);
            this.sliderListe();
        },
        methods: {
            handleNodeClick(data) {
                notification.Status('success', this, data.anaBaslik + ' slider seçildi.');
                this.sliderForm.oncekiSliderKodu = data.sliderKodu;
            },
            sliderListe() {
                sliderService.sliderKisaListe().then((response) => {
                    if (response.status === 200) {
                        this.sliderList = response.data;
                        this.sliderForm.oncekiSliderKodu = this.sliderList[parseInt(this.sliderList.length - 1)].sliderKodu;
                        console.log(this.sliderForm.oncekiSliderKodu);
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            sliderChange(val) {
                console.log(val);
                this.sliderForm.background = parseInt(val + 1);
            },
            resimChange(val) {
                this.sliderForm.resim = parseInt(val + 1);
            },
            getSliderDetay(sliderKodu) {
                let self = this;
                sliderService.sliderDetay(sliderKodu).then((response) => {
                    if (response.status === 200) {
                        self.linkVisible = true;
                        if (response.data['ondekiSliderKodu']) {
                            sliderService.sliderKisaListe().then((response) => {
                                if (response.status === 200) {
                                    this.sliderList = response.data;
                                    this.sliderForm.oncekiSliderKodu = this.sliderList.sliderKodu;
                                } else {
                                    notification.Status(response.status, this);
                                }
                            })
                        } else {
                            this.sliderForm.sayfaTuru = '0';
                        }
                        this.sliderForm.anaBaslik = response.data.anaBaslik;
                        this.sliderForm.altBaslik = response.data.altBaslik;
                        this.sliderForm.aciklama = response.data.aciklama;
                        if (response.data.link1 || response.data.link2) {
                            this.checked = true;
                        }
                        this.sliderForm.durum = response.data.durum;
                        this.sliderForm.background = response.data.background;
                        this.sliderForm.resim = response.data.resim;
                        this.sliderForm.link1 = response.data.link1;
                        this.sliderForm.link2 = response.data.link2;
                        this.sliderForm.linkButon1 = response.data.linkButon1;
                        this.sliderForm.linkButon2 = response.data.linkButon2;
                        this.sliderForm.dil.en.anaBaslik = response.data.dil.en.anaBaslik;
                        this.sliderForm.dil.en.altBaslik = response.data.dil.en.altBaslik;
                        this.sliderForm.dil.en.aciklama = response.data.dil.en.aciklama;
                        this.sliderForm.dil.en.linkButon1 = response.data.dil.en.linkButon1;
                        this.sliderForm.dil.en.linkButon1 = response.data.dil.en.linkButon1;
                        this.sliderDetayKlon = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            sliderGuncelle(formName) {
                for (var key in this.sliderDetayKlon) {
                    if (key !== 'dil') {
                        if (this.sliderDetayKlon[key] !== this.sliderForm[key]) {
                            if (this.sliderForm[key]) {
                                var item = {
                                    type: key,
                                    value: this.sliderForm[key]
                                };
                                this.updateData.push(item);
                            }
                        }
                    } else if (key === 'dil') {
                        for (var keyDil in this.sliderDetayKlon.dil.en) {
                            if (this.sliderDetayKlon.dil.en[keyDil] !== this.sliderForm.dil.en[keyDil]) {
                                if (this.sliderForm.dil.en[keyDil]) {
                                    var itemEn = {
                                        type: keyDil,
                                        value: this.sliderForm.dil.en[keyDil]
                                    };
                                    this.updateDataEN.push(itemEn);
                                }
                            }
                        }
                        if (this.updateDataEN.length !== 0) {
                            this.updateData.push({
                                type: "dil",
                                value: {
                                    en: this.updateDataEN,
                                }
                            })
                        }
                    }
                }
                // console.log(!_.isEmpty(this.ustSliderData));
                // if (!_.isEmpty(this.ustSliderData)) {
                //     this.updateData.push(this.ustSliderData)
                // }
                // console.log(this.updateData);
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (valid && this.updateData.length !== 0) {
                            sliderService.sliderGuncelle(this.updateSliderKodu, this.updateData).then((response) => {
                                if (response.status === 200) {
                                    notification.Status('success', this, 'Slider başarıyla guncellendi.');
                                    this.$refs[formName].resetFields();
                                } else if (response.status === 230) {
                                    notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir sayfa zaten mevcut');
                                } else {
                                    notification.Status(response.status, this);
                                }
                            })
                        } else
                            notification.Status('warning', this, 'Değişiklik yapılmadı!');
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                this.visibleUstSlider = false;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }

    .yanForm .card {
        margin-top: 10px;
    }
</style>